
const productPrice = document.getElementById('product-price');
const productPaymentOptions = document.getElementById('product-payment-options');
const hummTrigger = document.getElementById('humm-trigger');
const hummOverlay = document.getElementById('humm-overlay');
const klarnaTrigger = document.getElementById('klarna-trigger');
const klarnaOverlay = document.getElementById('klarna-overlay');


const numberToMoney = (number) => {
  const currencySymbol = document.body.getAttribute('data-currency-symbol');
  //const trailingZeroes = document.body.getAttribute('data-currency-sample').includes('.00');
  number = typeof number === 'string' ? parseFloat(number) : number; // string to float
  //number = trailingZeroes ? number.toFixed(2) : number; // apply decimal point
  number = number.toFixed(2).replace('.00', ''); // format decimal value only where decimal amount exists
  number = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); // add thousands commas
  let money = currencySymbol + number; // add currency symbol
  return money;
}


// Check if Humm is applicable on this product (applies for EUR only and product price > 500)
if(hummTrigger) {

  // const hummMerchantID = '0012600001fHmsFAAS'; // <-- ID used for pre-production env
  const hummMerchantID = '0017T00000McyLdQAJ';
  const hummWidgetAPIPath = 'https://cas4ujwgul.execute-api.eu-west-1.amazonaws.com/prod/widget';

  // Get data from Humm
  const applyHummData = (data) => {
    let plans = JSON.parse(data);
    //console.log(plans);

    // If plans are returned for this product price
    if(plans.length) {

      // Select last plan by default
      let plan = plans[plans.length -1];
      // If 3 plan options, select the middle one
      if(plans.length == 3) {
        plan = plans[1];
      }

      // Get frequency unit (e.g. 'month', 'fortnight')
      let planFrequencyUnit = plan.frequency.toLowerCase().includes('monthly') ? 'month' : plan.frequency.toLowerCase().includes('fortnightly') ? 'fortnight' : plan.frequency;

      // Set Humm trigger data
      //hummTrigger.querySelector('.humm_term-count').innerText = plan.term;
      productPaymentOptions.querySelector('.humm_offer-description').innerText = plan.offerDesc;
      productPaymentOptions.querySelector('.humm_term-amount').innerText = numberToMoney(plan.acctKeepingFee + plan.intFreeAmt);
      productPaymentOptions.querySelector('.humm_term-frequency').innerText = planFrequencyUnit;
      //hummTrigger.classList.add('active'); // show trigger after data applied
      // Set Humm overlay heading data
      hummOverlay.querySelector('.humm_offer-description').innerText = plan.offerDesc;
      hummOverlay.querySelector('.humm_total-credit').innerText = productPrice.innerText;
      // Set Humm overlay Upfront data
      hummOverlay.querySelector('.humm_application-fee').innerText = numberToMoney(plan.applicationFee);
      hummOverlay.querySelector('.humm_upfront-installment-payment').innerText = numberToMoney(plan.upfront);
      hummOverlay.querySelector('.humm_total-upfront-installment-payment').innerText = numberToMoney(plan.applicationFee + plan.upfront);
      // Set Humm overlay Installment Payments data
      hummOverlay.querySelector('.humm_installment-payment-interval').innerText = plan.frequency;
      hummOverlay.querySelector('.humm_account-keeping-fee').innerText = `${plan.term} x ${numberToMoney(plan.acctKeepingFee)}`;
      hummOverlay.querySelector('.humm_interest-free-installments').innerText = `${plan.intFreePeriod} x ${numberToMoney(plan.intFreeAmt)}`;
      hummOverlay.querySelector('.humm_remaining-installments').innerText = `${plan.intPeriod} x ${numberToMoney(plan.intAmt)}`;
      hummOverlay.querySelector('.humm_total-amount-payable').innerText = numberToMoney(plan.totAmtPayable);
      hummOverlay.querySelector('.humm_fees-included').innerText = numberToMoney(plan.applicationFee + (plan.term * plan.acctKeepingFee));
      // Show Humm plan
      productPaymentOptions.classList.remove('no-humm');
    }
    else {
      // If no plans returned from Humm, hide plan hook
      productPaymentOptions.classList.add('no-humm');
    }

  } // applyHummData()

  const fetchHummData = (price) => {
    // Price parameter needs to have no currency symbol and no commas. Decimal points are valid.
    // E.g. €5,990.49 should be converted to 5990.49
    price = price.slice(1).replace(',',''); // Remove currency symbol and commas
    let term = '0'; // '0' will return all plans for given price
    let url = `${hummWidgetAPIPath}/${hummMerchantID}/${price}/${term}`;
    ajaxCall('GET', url, applyHummData);
  }

  // Fetch Humm data on page load
  fetchHummData(productPrice.innerText);


  // Open Humm overlay
  hummTrigger.addEventListener('click', e => {
    hummOverlay.classList.add('active');
    handleFixedElements('hide');
  });


  // Click Apply button
  const hummApply = document.getElementById('humm-apply');
  hummApply.addEventListener('click', e => {
    let link = `https://apply.humm.ie/s/?channel=Web&source=${hummMerchantID}`;
    window.open(link, '_blank'); // open in new tab
  });


  // Update plan details when price is updated
  const updateHummData = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        //console.log('update Humm.');
        fetchHummData(productPrice.innerText);
      }
    }
  };
  // Create an observer on the product price (ref: https://www.smashingmagazine.com/2019/04/mutationobserver-api-guide/)
  const observer = new MutationObserver(updateHummData);
  observer.observe(productPrice, {childList: true});


  // Create an observer on related products (loaded with IntObs in sections/product-recommendations.liquid)
  const relatedProductsSection = document.getElementById('product-related');
  const relatedProductHummHook = () => {
    relatedProductsSection.querySelectorAll('.product-card').forEach(card => {
      makeProductHummHook(card.querySelector('.product-payment-plan-hook'));
    });
  }
  const relatedProductsObserver = new MutationObserver(relatedProductHummHook);
  relatedProductsObserver.observe(relatedProductsSection, {childList: true});


} // if hummTrigger



// Klarna

if(klarnaTrigger) {

  // Open Klarna overlay
  klarnaTrigger.addEventListener('click', e => {
    klarnaOverlay.classList.add('active');
    handleFixedElements('hide');
  });

  // Update plan details when price is updated
  const updateKlarnaData = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        // Get new "Pay in 3" term amount (1/3 price)
        let newTermAmount = numberToMoney(productPrice.innerText.replace(/[^0-9.]/g, '') / 3); // Amount as numbers and decimal only
        // Update Klarna trigger data
        productPaymentOptions.querySelector('.payment-option-klarna .term-amount').innerText = newTermAmount;
        // Update Klarna overlay data
        klarnaOverlay.querySelector('.total-price').innerText = productPrice.innerText;
        klarnaOverlay.querySelectorAll('.amount').forEach((amount) => amount.innerText = newTermAmount);
      }
    }
  };
  // Create an observer on the product price (ref: https://www.smashingmagazine.com/2019/04/mutationobserver-api-guide/)
  const observer = new MutationObserver(updateKlarnaData);
  observer.observe(productPrice, {childList: true});

}